// Console capture utility for debugging
let capturedLogs: string[] = [];
let captureEnabled = false;

export function startConsoleCapture() {
    captureEnabled = true;
    capturedLogs = [];

    // Store original console methods
    const originalLog = console.log;
    const originalWarn = console.warn;
    const originalError = console.error;

    // Override console methods
    console.log = (...args: any[]) => {
        if (captureEnabled) {
            capturedLogs.push(`[LOG] ${args.join(" ")}`);
            // Limit to last 1000 entries to prevent memory issues
            if (capturedLogs.length > 1000) {
                capturedLogs.shift();
            }
        }
        originalLog.apply(console, args);
    };

    console.warn = (...args: any[]) => {
        if (captureEnabled) {
            capturedLogs.push(`[WARN] ${args.join(" ")}`);
            if (capturedLogs.length > 1000) {
                capturedLogs.shift();
            }
        }
        originalWarn.apply(console, args);
    };

    console.error = (...args: any[]) => {
        if (captureEnabled) {
            capturedLogs.push(`[ERROR] ${args.join(" ")}`);
            if (capturedLogs.length > 1000) {
                capturedLogs.shift();
            }
        }
        originalError.apply(console, args);
    };
}

export function stopConsoleCapture() {
    captureEnabled = false;
}

export function getCapturedLogs(): string[] {
    return [...capturedLogs];
}

export function downloadCapturedLogs() {
    const logs = capturedLogs.join("\n");
    const blob = new Blob([logs], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `console-logs-${new Date().toISOString()}.txt`;
    a.click();
    URL.revokeObjectURL(url);
}

// Expose to window for easy access in console (only in browser environment)
if (typeof window !== "undefined") {
    (window as any).consoleCapture = {
        start: startConsoleCapture,
        stop: stopConsoleCapture,
        get: getCapturedLogs,
        download: downloadCapturedLogs,
    };
}